import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=1a00fb46&scoped=true&"
import script from "./CommentDialog.vue?vue&type=script&lang=ts&"
export * from "./CommentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CommentDialog.vue?vue&type=style&index=0&id=1a00fb46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a00fb46",
  null
  
)

export default component.exports